import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TbCircleCheckFilled, TbCircle, TbExternalLink } from "react-icons/tb";

export interface OnboardingStepDTO {
    id: string;
    titleKey: string;
    settingsSection?: string;
    linkTo?: string;
    /** Optional explanation under the title, for a step whose action isn't obvious from it. */
    hintKey?: string;
    done: boolean;
}

export function StepRow({ step, onNavigate }: { step: OnboardingStepDTO; onNavigate?: () => void }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const target = step.settingsSection ? `/settings?section=${step.settingsSection}` : step.linkTo;

    return (
        <div className={`onboarding-modal__step${step.done ? " onboarding-modal__step--done" : ""}`}>
            <span className="onboarding-modal__step-icon">
                {step.done ? <TbCircleCheckFilled /> : <TbCircle />}
            </span>
            <span className="onboarding-modal__step-label">
                {t(step.titleKey)}
                {step.hintKey && <span className="onboarding-modal__step-hint">{t(step.hintKey)}</span>}
            </span>
            {target && (
                <button
                    type="button"
                    className="onboarding-modal__step-link"
                    onClick={() => { onNavigate?.(); navigate(target); }}
                >
                    {step.settingsSection ? t("onboarding.openSettings") : t("onboarding.goTo")}
                    <TbExternalLink />
                </button>
            )}
        </div>
    );
}
